$(function() {
    const p = $("body").attr("p");
    const a = $("body").attr("a");
    const event_id = $("body").attr("event_id");

    const debounce = (func, delay) => {
        let timeoutId;
        return function(...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };

    if (p === "expense") {
        $('#start-date, #end-date').datetimepicker({
            controlType: 'select',
            oneLine: true,
            dateFormat: 'yy-mm-dd',
            timeFormat: 'HH:mm:ss',
            showButtonPanel: false,
            onSelect: function(dateText, inst) {
                const startDate = $("#start-date").val();
                const endDate = $("#end-date").val();

                debounce(getExpenseList(startDate, endDate), 500);
            },
        });

        $(document).on("click", ".pagination a", function (e) {
            e.preventDefault();
            let page = parseInt($(this).attr("href").substring(6));
            let startDate = $("#start-date").val();
            let endDate =  $("#end-date").val();
            getExpenseList(startDate, endDate, page);
        })

        function getExpenseList(startDate, endDate, page = 1) {
            // Implement the logic to fetch the expense list based on the date range
            $.ajax({
                type: 'POST',
                url: '/api/v1/private/expense/search',
                data: {
                    event_id: event_id,
                    start_date: startDate,
                    end_date: endDate,
                    page: page
                },
                dataType: 'json',
                success: function(response) {
                    console.log(response.html);
                    if (response.html) {
                        $('#expense-list-section').html(response.html);
                    }
                },
                error: function(data) {
                    if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                        document.location.href = data.responseJSON.redirect_url;
                    }
                }
            })
        }
    }

    if (p === "expense" && (a === "new" || a === "update")) {
        $(document).on('submit', '#expense-registration-form', function(e) {
            e.preventDefault();

            const description = $('textarea[name="expense_description"]').val().trim();
            const descriptionRequiredMessage = $('textarea[name="expense_description"]').data('required-message') || 'Description is required.';
            if (description === '') {
                showToast({
                    type: 'error',
                    message: descriptionRequiredMessage,
                    duration: 3000
                })
                $('textarea[name="expense_description"]').trigger('focus');
                return;
            }

            $.ajax({
                type: 'POST',
                url: '/api/v1/private/expense/new',
                data: $(this).serialize(),
                dataType: 'json',
                success: function(response) {
                    if (response.success) {
                        const successHtml = getAlertHtml(response.message, 'success');
                        $('#expense_msg').html(successHtml);
                        $('.card-box-to-hide').hide();
                        $("#back-to-expense-list-btn").hide();
                        $('#expense-register-btn').hide();

                        setTimeout(function () {
                            document.location.href = "/location/" + event_id + "/expense";
                        }, 2000);
                    }
                },
                error: function(data) {
                    if (data.responseJSON && data.responseJSON.error && data.responseJSON.error.message) {
                        showToast({
                            type: 'error',
                            message: data.responseJSON.error.message,
                            duration: 3000
                        });
                        return;
                    }

                    if (data.responseJSON.redirect_url && data.responseJSON.redirect_url !== '') {
                        document.location.href = data.responseJSON.redirect_url;
                        return;
                    }
                }
            });
        });
    }
})